export const NUMBER_OF_DOWNLOADS = 60;
export const NavHeight = 72;
export const appLink = "https://play.google.com/store/apps/details?id=com.gromo.partner&hl=en_IN";
export const SITE_URL = "https://gromo.in";
export const SITE_NAME = "Gromo";
